// src/App.jsx
import { useState } from "react";
import { useLocation } from "react-router-dom";

// Layout
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

// Noël
import SantaFloatingButton from "./components/noel/SantaFloatingButton";

// Chat interne
import ChatWindow from "./components/chat/ChatWindow";
import ChatButton from "./components/chat/ChatButton";

import "./App.css";
import { useAuth } from "./lib/auth";
// Hook de thème
import { useTheme } from "./lib/ThemeContext";

// Routes index
import AppRoutes from "./routes/AppRoutes";

function App() {
  const [isChatVisible, setIsChatVisible] = useState(false);
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  // Thème actif (dark / christmas / autre)
  const { activeTheme } = useTheme();

  const isChristmas = activeTheme === "christmas";

  // On cache certaines choses sur les pages Père Noël (toutes les routes /pere-noel...)
  const isSantaPage = location.pathname.startsWith("/pere-noel");

  return (
    <div className="min-h-screen flex flex-col transition-colors duration-200">
      {/* --- ANIMATION NEIGE (Uniquement si thème Noël actif) --- */}
      {isChristmas && (
        <div className="snow-container pointer-events-none">
          <div className="snow layer1"></div>
          <div className="snow layer2"></div>
          <div className="snow layer3"></div>
        </div>
      )}

      <Header />

      <main className="flex-grow bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-200">
        <AppRoutes />
      </main>

      {/* --- Chat Interne (Membres & Admin) --- */}
      {isChatVisible ? (
        <ChatWindow onClose={() => setIsChatVisible(false)} />
      ) : (
        isAuthenticated &&
        (user?.role === "admin" || user?.role === "member") && (
          <ChatButton
            toggleChat={() => setIsChatVisible(!isChatVisible)}
            isChatOpen={isChatVisible}
          />
        )
      )}

      {/* --- Bouton Père Noël (Sauf sur les pages Père Noël) --- */}
      {!isSantaPage && <SantaFloatingButton />}

      {/* --- Footer (Sauf sur les pages Père Noël si tu veux les garder "full screen") --- */}
      {!isSantaPage && <Footer />}
    </div>
  );
}

export default App;
